<h1 matDialogTitle>
  <ng-container *ngIf="!data.company.id && !data.isRegistrationRequest">New Company</ng-container>
  <ng-container *ngIf="!data.company.id && data.isRegistrationRequest">Company subscription request</ng-container>
  <ng-container *ngIf="data.company.id">Edit Company</ng-container>
</h1>
<mat-dialog-content>

  <aw-company-form [company]="data.company" [isRegistrationRequest]="data.isRegistrationRequest"
    (saved)="dialogRef.close(true)" (canceled)="dialogRef.close(false)"></aw-company-form>

</mat-dialog-content>